import React from "react";

function normalizeColor(color, fallback = "#ffffff") {
  if (typeof color !== "string") return fallback;
  let temp = color.trim();
  if (!temp.startsWith("#")) temp = `#${temp}`;
  if (temp.length !== 7 && temp.length !== 4) return fallback;
  return temp;
}

export default function FooterClassic({ config }) {
  // usa mesma lógica do navbar
  const footerBgColor = normalizeColor(config.navbar?.colornav, "#ffffff");
  const footerTextColor = normalizeColor(
    config.navbar?.colornavtext,
    "#000000"
  );

  return (
    <>
      <footer
        key="rodape"
        style={{
          backgroundColor: footerBgColor,
          color: footerTextColor,
          padding: "3rem 1rem",
        }}
      >
        <div className="container">
          <div
            className="row align-items-center mb-5 text-center"
            style={{ fontFamily: "Axiforma, sans-serif" }}
          >
            <div className="col-md-3 mb-4 mb-md-0">
              {config.logo && (
                <img
                  src={config.logo}
                  alt="Logo"
                  className="img-fluid"
                  style={{
                    width: "180px",
                    maxWidth: "100%",
                    height: "auto",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.transform = "scale(1.05)")
                  }
                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                />
              )}
            </div>

            <div className="col-md-9">
              <div className="row text-center">
                {config.footer?.endereco && (
                  <div className="col-md-4 mb-4 mb-md-0">
                    <h5 className="mb-3 fw-bold">Endereço</h5>
                    <p className="mb-0" style={{ lineHeight: "1.6" }}>
                      {config.footer.endereco}
                    </p>
                  </div>
                )}

                <div className="col-md-4 mb-4 mb-md-0">
                  <h5 className="mb-3 fw-bold">Contato</h5>
                  <div className="d-flex flex-column gap-2 align-items-center">
                    {config.footer?.telefone && (
                      <a
                        href={`tel:${config.footer.telefone}`}
                        className="text-decoration-none d-inline-flex align-items-center justify-content-center"
                        style={{ color: footerTextColor, gap: 8 }}
                      >
                        <i className="bi bi-telephone fs-5"></i>
                        {config.footer.telefone}
                      </a>
                    )}
                    {config.footer?.email && (
                      <a
                        href={`mailto:${config.footer.email}`}
                        className="text-decoration-none d-inline-flex align-items-center justify-content-center"
                        style={{ color: footerTextColor, gap: 8 }}
                      >
                        <i className="bi bi-envelope fs-5"></i>
                        {config.footer.email}
                      </a>
                    )}
                  </div>
                </div>

                {config.footer?.facebook && (
                  <div className="col-md-4 d-flex flex-column gap-2 align-items-center">
                    <h5 className="mb-3 fw-bold">Redes Sociais</h5>
                    <a
                      href={`https://facebook.com/${config.footer.facebook}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none d-inline-flex align-items-center justify-content-center"
                      style={{ color: footerTextColor, gap: 8 }}
                    >
                      <i className="bi bi-facebook fs-5"></i>
                      Siga-nos
                    </a>
                    {config.navbar?.link_instagram && (
                      <a
                        href={`https://instagram.com/${config.navbar.link_instagram}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-decoration-none d-inline-flex align-items-center justify-content-center"
                        style={{ color: footerTextColor, gap: 8 }}
                      >
                        <i className="bi bi-instagram fs-5"></i>
                        Siga-nos
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            className="text-center mt-5 pt-3"
            style={{
              borderTop: `1px solid rgba(255,255,255,0.1)`,
            }}
          >
            <small>
              © {new Date().getFullYear()} {"Lotemobile"} - Todos os direitos
              reservados
            </small>
          </div>
        </div>
      </footer>
    </>
  );
}
